module.exports = __webpack_public_path__ + "5d0ab4c56ea621101cbce0487d8e41b4.svg";


//////////////////
// WEBPACK FOOTER
// ./src/svgs/hero/app-marketplace-hero_mobile@2x.svg
// module id = 2443
// module chunks = 0